import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpService, NotificationService, OrderAgent, TmsWebBaseEditCreateService } from 'tms-lib';

@Injectable({
  providedIn: 'root',
})
export class OrderAgentService extends TmsWebBaseEditCreateService<OrderAgent, OrderAgent> {
  constructor(
    protected httpService: HttpService,
    protected notificationService: NotificationService,
  ) {
    super('OrderAgent', $localize`Order Agent`, httpService, notificationService);
  }

  getForSalesOrderHeader(id: string): Observable<OrderAgent[]> {
    return this.httpService.get<OrderAgent[]>(`${this.apiUrl}/GetForSalesOrderHeader?id=${id}`);
  }
}
